import { getView, requireAuth } from '@/lib/utils';

export default {
  path: '/jobs',
  name: 'jobs',
  component: getView('pages/PageJobs'),
  beforeEnter: requireAuth,
  // meta: {
  //   roles: ['bidder'],
  // },
};
